export default __webpack_public_path__ + "static/Bäckerbild 3-3d039ba1be2822d28d8813937ceb1632.jpg";